import axios from 'axios';
const treasuryBackendUrl = '/apps/mifid/api';
export default {
	init() {
		return axios.get(`${treasuryBackendUrl}/rts27`);
	},
	download(data) {
		return axios({
			method: 'post',
			url: `${treasuryBackendUrl}/rts27`,
			responseType: 'blob',
			data
		});
	}
};
